// LeftPanelContext.tsx
import type { ReactNode } from 'react';
import React, { createContext, useContext, useState } from 'react';

interface LeftPanelContextType {
  refreshLeftPanel: boolean;
  toggleLeftPanelRefresh: () => void;
  setRefreshLeftPanel: (refreshLeftPanel: boolean) => void;
}

const LeftPanelContext = createContext<LeftPanelContextType | undefined>(
  undefined
);

interface LeftPanelProviderProps {
  children: ReactNode;
}

export const LeftPanelProvider: React.FC<LeftPanelProviderProps> = ({
  children,
}) => {
  const [refreshLeftPanel, setRefreshLeftPanel] = useState<boolean>(false);

  const toggleLeftPanelRefresh = () => {
    setRefreshLeftPanel((prev) => !prev);
  };

  return (
    <LeftPanelContext.Provider
      value={{
        refreshLeftPanel,
        toggleLeftPanelRefresh,
        setRefreshLeftPanel,
      }}
    >
      {children}
    </LeftPanelContext.Provider>
  );
};

export const useLeftPanelContext = (): LeftPanelContextType => {
  const context = useContext(LeftPanelContext);
  if (!context) {
    throw new Error(
      'useLeftPanelContext must be used within a LeftPanelProvider'
    );
  }
  return context;
};
